module.exports = __webpack_public_path__ + "static/giant_four_armed_gargoyle-3203d46a95989383b25052710cd6f2d2.jpeg";